import React from 'react'
import { RecommenderSettings } from '@/api/types'
import { Switch } from '@/components/Switch'
import { MealDivisionHeuristics } from './MealDivisionHeuristics'
import { DayHeuristics } from './DayHeuristics'
import { WeekHeuristics } from './WeekHeuristics'

import './RecommenderSettingsForm.css'

type Props = {
  recommenderSettings: RecommenderSettings
  setRecommenderSettings: (settings: RecommenderSettings) => void
} & React.HTMLAttributes<HTMLDivElement>

export function RecommenderSettingsForm({
  recommenderSettings,
  setRecommenderSettings,
  ...props
}: Props) {
  function setDayImprovement(value: boolean) {
    setRecommenderSettings({
      ...recommenderSettings,
      runDayImprovement: value,
    })
  }

  function setWeekImprovement(value: boolean) {
    setRecommenderSettings({
      ...recommenderSettings,
      runWeekImprovement: value,
    })
  }

  return (
    <div {...props}>
      <div className="heuristics-grid">
        <MealDivisionHeuristics
          className="meal-division"
          recommenderSettings={recommenderSettings}
          setRecommenderSettings={setRecommenderSettings}
        />
        <DayHeuristics
          className="day"
          recommenderSettings={recommenderSettings}
          setRecommenderSettings={setRecommenderSettings}
          setDayImprovement={setDayImprovement}
        />
        <WeekHeuristics
          className="week"
          recommenderSettings={recommenderSettings}
          setRecommenderSettings={setRecommenderSettings}
          setWeekImprovement={setWeekImprovement}
        />
      </div>
    </div>
  )
}
